import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Post } from '../models/post';

@Injectable({
  providedIn: 'root'
})
export class PostService {

  private readonly API = `https://api-msoperacional.unionsolutions.com.br/painel/blog/`;

  constructor(private http: HttpClient) { }

  getPosts(currentPage, qtdPerPage) {
    return this.http.get<Post[]>(this.API + "posts/?currentPage=" + currentPage + "&qtdPerPage=" + qtdPerPage).toPromise();
  }

  getDestaque() {
    return this.http.get<Post[]>(this.API + "destaque").toPromise();
  }

  getCategories() {
    return this.http.get<any[]>(this.API + "categorias").toPromise();
  }

  getPostById(id){
    return this.http.get<Post>(this.API + "post/" + id).toPromise();
  }

  getPostsByCategorias(categoriaSlug, currentPage, qtdPerPage) {
    return this.http.get<Post[]>(this.API +
      "posts/categoria/?categoriaSlug=" + categoriaSlug
      + "&currentPage=" + currentPage
      + "&qtdPerPage=" + qtdPerPage).toPromise();
  }

}
